import { FunctionComponent, useState } from 'react';

import { useStatusGame, useGames, useSuperPrizeMode } from '../hooks';
import SliderItem from './SliderItem';
import './caseOpening.scss';
import Cursor from './cursor1';
import _ from 'lodash';
import { useConfig, useProfile } from '~frontend/components/hooks';
import ButtonsCase from '../playButton/ButtonsCase';

const Slider: FunctionComponent<any> = ({ isFastEndBtnClicked }) => {
  const [getGames] = useGames();
  //const [isSuperPrizeGame] = useSuperPrizeMode();

  const getConfig = useConfig();
  const getProfile = useProfile();
  // console.log('getConfig', getConfig);
  // console.log('getProfile', getProfile);

  const [gameStatus] = useStatusGame();

  const [isAnimated, setIsAnimated] = useState(false);

  // const isBonusPrize = () => {
  //   const prizesArr = [];
  //   let isBonus = false;
  //   getGames.forEach((getGame) => {
  //     console.log('getGame');
  //     const winItemPrice = getGame.getGame.getItem.price;
  //     const casePrice = getGame.getGame.getCase.price;
  //     const caseBonusPrizeFormula = getConfig.caseBonusPrizeFormula?.props.find(
  //       (item) =>
  //         casePrice > item.minCasePrice && casePrice < item.maxCasePrice,
  //     );

  //     //console.log('caseBonusFormula', caseBonusPrizeFormula);

  //     const {
  //       minCasePrice,
  //       maxCasePrice,
  //       winItemPricePercent,
  //       bonusChancePercent,
  //       bonusChancePercentWhenModeActive,
  //       caseCostFactor,
  //       bloggerWinItemPricePercent,
  //       bloggerBonusChancePercent,
  //       bloggerBonusChancePercentWhenModeActive,
  //       bloggerCaseCostFactor,
  //     } = caseBonusPrizeFormula || {};

  //     //Group 4 is bloggers group
  //     const isBloggerProfile = getProfile?.group === 4 ? true : false;
  //     //console.log('isBloggerProfile', isBloggerProfile);

  //     if (casePrice < minCasePrice || casePrice > maxCasePrice)
  //       prizesArr.push({ gameId: getGame?.getGame.id, isBonusPrize: false });
  //     let bonusChance = 0;
  //     if (!isBloggerProfile) {
  //       //console.log('winItemPrice', winItemPrice);
  //       if (winItemPrice < casePrice * winItemPricePercent)
  //         prizesArr.push({ gameId: getGame?.getGame.id, isBonusPrize: false });
  //       bonusChance = isSuperPrizeGame
  //         ? bonusChancePercentWhenModeActive
  //         : bonusChancePercent;
  //       // console.log('bonusChance', bonusChance);
  //     } else {
  //       // console.log('blogwinItemPrice', winItemPrice);
  //       // console.log(
  //       //   'blog+winitempercent',
  //       //   casePrice + casePrice * bloggerWinItemPricePercent,
  //       // );
  //       if (winItemPrice < casePrice * bloggerWinItemPricePercent)
  //         prizesArr.push({ gameId: getGame?.getGame.id, isBonusPrize: false });
  //       bonusChance = isSuperPrizeGame
  //         ? bloggerBonusChancePercentWhenModeActive
  //         : bloggerBonusChancePercent;
  //       // console.log('bllogbonusChance', bonusChance);
  //     }

  //     isBonus = Math.random() < bonusChance;
  //     //Если есть уже хоть одна игра которая будет бонусной, то остальные делаем обычными в любом случае
  //     const hasBonusPrize = prizesArr.some((obj) => obj.isBonusPrize === true);

  //     if (hasBonusPrize) {
  //       prizesArr.push({ gameId: getGame?.getGame.id, isBonusPrize: false });
  //     } else {
  //       prizesArr.push({ gameId: getGame?.getGame.id, isBonusPrize: isBonus });
  //     }
  //   });

  //   //console.log('BonusArr', prizesArr);

  //   return prizesArr;
  // };

  const handleClick = () => {
    setIsAnimated(!isAnimated);
  };

  return (
    <>
      <div
        style={{
          display: ![2, 3].includes(gameStatus) ? 'none' : 'block',
        }}
        className={`case_previews ${
          isAnimated ? 'case_previews_animated' : ''
        }`}
        onClick={handleClick}
      >
        <div className="case_previews_shadows_lr">
          <div
            className={`case_previews_shadows_item ${
              isAnimated ? 'case_previews_shadows_item_animated' : ''
            }`}
          ></div>
          <div
            className={`case_previews_shadows_item ${
              isAnimated ? 'case_previews_shadows_item_animated' : ''
            }`}
          ></div>
        </div>
        {_.map(_.chunk(getGames, 5), (getGames, index) => (
          <div
            key={index}
            className={`case-play-slider isGame-${gameStatus} ${
              _.size(getGames) > 2 &&
              'case-play-slider-vertical case-play-slider-many-items'
            }`}
          >
            <div className="shadow-left"></div>
            <div className="shadow-right"></div>
            <div className="case-play-slider-arrow" />
            <div
              className={`case-open-slider ${
                _.size(getGames) > 2 ? 'case-open-slider-vertical' : ''
              }`}
            >
              <>
                {' '}
                {getGames.map((getGame) => (
                  <SliderItem
                    getGame={getGame}
                    key={getGame?.getGame?.id}
                    //isBonusPrize={isBonusPrize()}
                    isFastEndBtnClicked={isFastEndBtnClicked}
                  />
                ))}
              </>
            </div>
          </div>
        ))}
      </div>

      {/* <br />
      <br /> */}
      {/* <section
        style={{
          display: ![2, 3].includes(gameStatus) ? 'block' : 'block',
        }}
        className={`${isAnimated ? 'case_previews_animated' : ''}`}
      >
        <div className="case_previews_shadows_lr">
          <div
            className={`case_previews_shadows_item ${
              isAnimated ? 'case_previews_shadows_item_animated' : ''
            }`}
          ></div>
          <div
            className={`case_previews_shadows_item ${
              isAnimated ? 'case_previews_shadows_item_animated' : ''
            }`}
          ></div>
        </div>
        {_.map(_.chunk(getGames, 5), (getGames, index) => (
          <div
            key={index}
            className={`case-play-slider isGame-${gameStatus} ${
              _.size(getGames) > 1 && 'case-play-slider-vertical'
            }`}
          >
            <div className="shadow-left"></div>
            <div className="shadow-right"></div>
            <div className="case-play-slider-arrow" />
            <div className="case-open-slider">
              {getGames.map((getGame) => (
                <SliderItem getGame={getGame} key={getGame?.getGame?.id} />
              ))}
            </div>
          </div>
        ))}
        {[2, 3].includes(gameStatus) && (
          <div className="case_previews_cursor">
            <div className="case_previews_cursor_item">
              <Cursor />
            </div>
            <div className="case_previews_cursor_item">
              <Cursor />
            </div>
          </div>
        )}
      </section> */}
    </>
  );
};

export default Slider;
